import { Routes }             from '@angular/router';

import { Error404Component }  from "./screens/errors/404.component";
import { Error503Component }  from "./screens/errors/503.component";

export const ROUTES: Routes = [
  {
		path: "404",
		component: Error404Component
  },
  {
		path: "503",
		component: Error503Component
	},
  {
		path: "login",
		loadChildren: "app/screens/security/+login/login.module#LoginModule"
	},
	{
		path: "reset",
		loadChildren: "app/screens/security/+reset-password/module#ResetPasswordModule"
	},
  { 
    path: "s",
    loadChildren: "app/screens/screen.module#ScreenModule"
	},
	{ 
    path: "checker",
    loadChildren: "app/screens/checker/checker.module#CheckerModule"
  },
  {
		path: "",
		redirectTo: "s",
		pathMatch: "full"
	},
	{ 
		path: "**", 
		redirectTo: "404"
	}
];



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/app.routes.ts